// ChatGPT API Configuration
const CHATGPT_API_URL = "https://api.openai.com/v1/chat/completions";
// const CHATGPT_API_KEY = process.env.OPENAI_API_KEY;
// Cloudinary Configuration
const CLOUDINARY_CLOUD_NAME = "dbproqvr5"; // From Cloudinary dashboard
const CLOUDINARY_UPLOAD_PRESET = "Leaflet_Image "; // From Cloudinary settings

export const uploadImageToCloudinary = async (
  image: string | Blob
): Promise<string> => {
  try {
    const formData = new FormData();

    // Handle Base64 string or Blob
    if (typeof image === "string") {
      // Directly send the Base64 string to Cloudinary
      formData.append("file", image);
    } else {
      formData.append("file", image);
    }

    formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/upload`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      const errorMessage = await response.text();
      console.error("Cloudinary API Error:", errorMessage);
      throw new Error(`Upload failed: ${response.statusText}`);
    }

    const data = await response.json();
    return data.secure_url; // Public URL of the uploaded image
  } catch (error) {
    console.error("Error uploading to Cloudinary:", error);
    throw new Error("Failed to upload image.");
  }
};

export const fetchChatResponseWithImage = async (
  prompt: string,
  imageUrl: string
): Promise<string> => {
  const res = await fetch("/api/chatkey", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt, imageUrl }), // server route will add OpenAI auth
  });

  if (!res.ok) throw new Error(await res.text());
  const { text } = await res.json();
  return text as string;
};

export const fetchSearchQuery = async (prompt: string): Promise<string> => {
  // const response = await fetch("/api/chatkey", {
  //   method: "POST",
  //   headers: { "Content-Type": "application/json" },
  //   body: JSON.stringify({
  //     model: "gpt-5-chat-latest",
  //     messages: [
  //       {
  //         role: "user",
  //         content: prompt,
  //       },
  //     ],
  //     temperature: 0.3,
  //     top_p: 0.8,
  //     max_completion_tokens: 450, // ✅ correct param for this model
  //     // frequency_penalty: 0.5,
  //     // presence_penalty: 0.3,
  //     // max_tokens: 1200,
  //   }),
  // });
  const response = await fetch("/api/chatkey", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt }), // ✅ MATCHES SERVER REQUIREMENTS
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error("ChatGPT API Error:", errorText);
    throw new Error(
      `OpenAI request failed: ${response.status} ${response.statusText}`
    );
  }

  const data = await response.json();
  return data.text as string;
};
